<div 
    class="pre-maintenance-banner" 
    [class]="position" 
    *ngIf="isEnabled && countdownActive"
    role="alert"
    aria-live="polite"
>
    <div class="pm-content">
        <i class="pi pi-exclamation-triangle pm-icon" aria-hidden="true"></i>
        <div class="pm-text">
            <h4>Mantenimiento Programado</h4>
            <p>{{ preMaintenanceMsg }}</p>
        </div>
        <div class="pm-countdown">
            <span class="countdown-time" [attr.aria-label]="'Tiempo restante: ' + countdownDisplay">
                {{ countdownDisplay }}
            </span>
        </div>
    </div>
</div>